import { ObservableFromFetch } from "../ObservableFromFetch"
import OrderSecurityOverrideData from "./Model/OrderSecurityOverrideData"

export default function OrderSecurityOverrideGetObservable(roleID: number, userID: number) {
  const requestBody: string = JSON.stringify({
    RoleID: roleID,
    ApplicationUserIDFrom: userID
  })
  return ObservableFromFetch<OrderSecurityOverrideData>("FFOrderRoleOrderSecurity/GetOrderSecurityOverride", requestBody)
}
